import React, { Component } from 'react';
import { connect } from 'react-redux';
import Table from '../../components/UI/Table/Table';
import classes from './DeliveryOrders.css';

class DeliveryOrders extends React.PureComponent {
    componentDidMount() {
    }

    toggleOrder = (e) => {
        let orderId = e.currentTarget.getAttribute('oid');
        this.props.orderUpdated(orderId);
    }

    render() {
            var data = [];
            let pl = "30px";
            let fifty = "50px";
            let oneFifty = "150px";
            let seventyFive = "75px";

            if (window.innerWidth < 500) {
                pl = "5px";
                fifty = "40px";
                oneFifty = "100px";
                seventyFive = "50px";
            }

            for (let l in this.props.orders) {
                if (this.props.orders[l].deliveryId == this.props.deliveryId) {
                    data.push(
                        {
                            oid: this.props.orders[l].orderId,
                            data: [{
                                value: this.props.orders[l].orderId,
                                style: { paddingLeft: pl, width: seventyFive },
                                full: false
                            },
                            {
                                value: this.props.orders[l].name,
                                style: { width: oneFifty, paddingLeft: pl },
                                full: false
                            },
                            {
                                value: this.props.orders[l].address,
                                style: { width: "250px", paddingLeft: pl },
                                full: true
                            },
                            {
                                value: this.props.orders[l].hardwoodBags,
                                style: { width: fifty, paddingLeft: pl },
                                full: false
                            },
                            {
                                value: this.props.orders[l].cedarBags,
                                style: { width: fifty, paddingLeft: pl },
                                full: false
                            },
                            {
                                value: this.props.orders[l].blackBags,
                                style: { width: fifty, paddingLeft: pl },
                                full: false
                            },
                            {
                                value: this.props.orders[l].redBags,
                                style: { width: fifty, paddingLeft: pl },
                                full: false
                            },
                            {
                                value: this.props.orders[l].totalBags,
                                style: { width: fifty, paddingLeft: pl },
                                full: false
                            }
                            ]
                        }
                    )
                }
            }

            var header = [
                {
                    name: "Order",
                    style: { paddingLeft: pl, width: seventyFive }
                },
                {
                    name: "Name",
                    style: { width: oneFifty, paddingLeft: pl }
                },
                {
                    name: "Address",
                    style: { width: "250px", paddingLeft: pl },
                    full: true
                },
                {
                    name: "Hwd",
                    style: { width: fifty, paddingLeft: pl }
                },
                {
                    name: "Cdr",
                    style: { width: fifty, paddingLeft: pl }
                },
                {
                    name: "Blk",
                    style: { width: fifty, paddingLeft: pl }
                },
                {
                    name: "Red",
                    style: { width: fifty, paddingLeft: pl }
                }
                ,
                {
                    name: "Total",
                    style: { width: fifty, paddingLeft: pl }
                }
            ];

            return (
                <Table header={header} data={data} editPopupHandler={this.toggleOrder}></Table>
            );
        
    }
}

const mapStateToProps = state => {

    return {
        orders: state.orders.orders
    };
};

export default connect(mapStateToProps)(DeliveryOrders);


// WEBPACK FOOTER //
// ./src/components/DeliveryOrders/DeliveryOrders.js